/**
 * @file 通用错误页
 * @author liuxin01
 */
define(function (require, exports) {
    'use strict'

    var etpl = require('cobble/util/etpl')
    var inClient = require('./classroom/function/inClient')
    var instance = require('cobble/util/instance')

    var language = require('classroom/language/main')

    var bearsurpriseDir = BJY.srcOrigin + require('url!./img/error-tips.svg')
    var urlQuery = require('cobble/util/url').parseQuery(location.search)
    var goToClientLogin = require('./common/function/goToClientLogin')

    var tplData = {}

    var KICK_OUT_CODE = '10000'

    var renderErrTipTpl = etpl.compile(''
            + '<div id="main" class="${className}">'
            + '<div class="tip-img">'
            + '<img src="${errorImageDir}">'
            + '</div>'
            + '<div class="footer">'
            + '<div class="tip-text">'
            + '${tip}'
            + '</div>'
            + '<!-- if: ${inClient} -->'
            + '<div class="go-back">'
            + '<div class="btn-primary return">'
            + '<!-- if: ${isKickOut} -->'
            + language.BUTTON_SUBMIT
            + '<!-- else -->'
            + language.BUTTON_RETURN
            + '<!-- /if -->'
            + '</div>'
            + '</div>'
            + '<!-- /if -->'
            + '</div>')

    var renderErrTip = function (data) {
        return renderErrTipTpl(data)
    }

    exports.init = function (data) {
        tplData.inClient = inClient() || !!window.ClientBridge
        var body = instance.body
        var mainelement = $('#main')

        tplData.tip = data.msg
        if (data.partner_config && data.partner_config.special_customer) {
            if (data.partner_config.special_customer === 'apple') {
                tplData.errorImageDir = BJY.srcOrigin + require('url!./img/errorPageImageApple.png')
                tplData.className = 'bjy-apple'
            }
            else {
                tplData.errorImageDir = bearsurpriseDir
            }
        }
        else {
            tplData.errorImageDir = bearsurpriseDir
        }

        if (urlQuery.type == KICK_OUT_CODE) {
            tplData.isKickOut = true
        }

        mainelement.replaceWith(renderErrTip(tplData))
        var goBackBtnElement = $('.go-back')

        if (goBackBtnElement) {
            goBackBtnElement.on('click', '.return', function () {
                if (tplData.isKickOut) {
                    if (window.bjyAppVersion && BJY.checkVersion('6.8.5') && BJY.cef || window.ClientBridge) {
                        BJY.cef.closeClient()
                    }
                    else {
                        goToClientLogin()
                    }
                }
                else {
                    goToClientLogin()
                }
            })
        }
    }
})
